import React from 'react';
import { useTranslation } from 'react-i18next';

import { Spinner, GenericResult } from 'components';

import { BankTransferInformation } from './BankTransferInformation';
import { SecondaryInfoText } from '../components/SecondaryInfoText';
import { useBankTransferInfo } from '../hooks';

export const BankTransferContent = (): JSX.Element => {
  const { t } = useTranslation();

  const { data, error } = useBankTransferInfo();

  if (!data && !error) return <Spinner />;

  if (error || !data) return <GenericResult hideDefaultExtra />;

  return (
    <>
      <p>{t('cms.shortfall.settle.bankTransfer.instruction')}</p>

      <BankTransferInformation {...data} />

      <SecondaryInfoText content={t('cms.shortfall.settle.bankTransfer.info')} />
    </>
  );
};
